import { React } from 'react';

function Euclidean(props) {
  return (
    <div className="project-content-container" id="euclidean-project-content-container">
      <div className="project-content-container-section project-overview">
        <h1>Overview</h1>
        <p>Created in December 2015, the Euclidean Project was a quick, intuitive, simple, digital geometry constructor made as a gift for my 9th grade geometry teacher (yeah, it was a while ago...). It was available for desktop and mobile users so that they could explore geometry stuffs on any device.</p>
      </div>
    </div>
  );
}

export default Euclidean;